import { CommonModel } from '@telialt/models/src/CommonModel';
import { datadogLogger } from '@telialt/utils/src/datadog/datadogLogger';
import { DDComponent } from '@telialt/utils/src/datadog/setup';

import { apiGetSearchQuery } from '../../api';
import { SEARCH_CONTENT_SUGGESTIONS_COUNT } from '../../constants';
import { ContentSearchItem, SearchQueryKeysMap, SearchQueryParams } from '../../model';
import { getQueryKeyPrefixBySegment } from '../../utils/segment';

type Params = {
    searchText: string;
    segment: CommonModel.Segment;
    queryKeys: SearchQueryKeysMap;
    signal?: AbortSignal;
};

export const loadContentSuggestions = async ({ searchText, segment, queryKeys, signal }: Params) => {
    const queryKeyPrefix = getQueryKeyPrefixBySegment(segment);

    const searchParams: SearchQueryParams = {
        searchText,
        offset: 0,
        limit: SEARCH_CONTENT_SUGGESTIONS_COUNT,
    };

    try {
        const response = await apiGetSearchQuery<ContentSearchItem>(
            queryKeys[`${queryKeyPrefix}-content`],
            searchParams,
            signal,
        );

        return { content: response.data };
    } catch (error) {
        datadogLogger().warn(error, { component: DDComponent.Search });

        return { error };
    }
};
